enum LocalCacheKeys {
  CHART_OPTIONS = 'chartOptions',
  CHOSEN_MEMBERSHIP_TYPE = 'chosenMembershipType',
  ORGANIZATION = 'organization',
}

export default LocalCacheKeys;
